<template>
  <Catalogs
    title="Гражданства"
    create-text="Новое"
    :fetch-data="fetchData"
    :route-create="'CitizenshipAdd'"
    :route-edit="'CitizenshipEdit'"
    :route-view="'CitizenshipView'"
    :route-path="'/citizenships'"
    :can-edit="canEditCitizenshipCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
import permissions, {PERM} from "../../../utilites/permissions";
import Catalogs from "../Catalogs.vue";

export default {
  name: "Citizenships",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  methods: {
    async fetchData(data) {
      return await this.getCitizenships(data);
    },
    canEditCitizenshipCatalogs() {
      return this.hasPermission([PERM.CATALOG_CITIZENSHIPS_EDIT]);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/Citizenships/Citizenships.vue